import React from 'react';
import { BubbleButton } from './BubbleUI';
import { BubbleButtonProps } from './BubbleUI/BubbleButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { capitalize } from '@go-shared/lib/string';
import {
  getMultiPropertyKind,
  MultiPropertyItem,
  MultiPropertyItemBase,
} from '@go-shared/lib/libraries';

interface AccessGlanceButtonPropsBase<T extends MultiPropertyItem<MultiPropertyItemBase>> {
  item?: T;
  iconClassName?: string;
}

export type AccessGlanceButtonProps<T extends MultiPropertyItem<MultiPropertyItemBase>> = Omit<
  BubbleButtonProps,
  'variant'
> &
  AccessGlanceButtonPropsBase<T>;

export default function AccessGlanceButton<T extends MultiPropertyItem<MultiPropertyItemBase>>(
  props: AccessGlanceButtonProps<T>
) {
  const { item, className: propClasses, iconClassName: propIconClasses, ...rest } = props;

  const classes = ['w-full text-xs border border-0-5 shadow'];
  if (propClasses) classes.push(propClasses);

  const iconClasses = ['mr-2'];
  if (propIconClasses) iconClasses.push(propIconClasses);

  const cntStatus = getMultiPropertyKind(item);

  return (
    <BubbleButton
      {...rest}
      variant="white"
      className={classes.join(' ')}
      style={{ borderColor: '#eeeeee' }}
    >
      <div className={`flex items-center text-${cntStatus.variant}`}>
        <FontAwesomeIcon fixedWidth className={iconClasses.join(' ')} icon={cntStatus.icon} />
        <span>{capitalize(cntStatus.status)}</span>
      </div>
    </BubbleButton>
  );
}
